import { render, staticRenderFns } from "./FlatDropdownMenu.component.vue?vue&type=template&id=5da29437&"
import script from "./FlatDropdownMenu.component.vue?vue&type=script&lang=ts&"
export * from "./FlatDropdownMenu.component.vue?vue&type=script&lang=ts&"
import style0 from "./FlatDropdownMenu.component.vue?vue&type=style&index=0&id=5da29437&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports